import BlankTemplate from '../templates/Blank';

import homepage from '../pages/homepage';

export const routes = [
  // BUYING FLUX

  {
    path: '/',
    page: homepage,
    title: 'BluePharm®',
    isPublic: true,
    template: BlankTemplate,
  },
];
